// extracted by mini-css-extract-plugin
module.exports = {"white":"_2787f3"};